import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import { SaGLogo } from '@swf/poker';

import SitAndGoLogo from '../../../assets/sit-and-go.svg';
import type { StepKey } from '../../../types';
import { StepKeyName } from '../../../types';

import { TXTCLI_Final, TXTCLI_Tournament } from './BannerName.messages.json';
import styles from './BannerName.scss';

interface BannerNameProps {
  stepKey: StepKey;
}

const BannerName: React.FC<BannerNameProps> = ({ stepKey }) => {
  const { formatMessage } = useIntl();
  const final = formatMessage(TXTCLI_Final).toUpperCase();
  const tournament = formatMessage(TXTCLI_Tournament).toUpperCase();

  switch (stepKey) {
    case StepKeyName.step1:
      return <SaGLogo className={styles.sagLogo} />;

    case StepKeyName.step2SNG:
      return <SitAndGoLogo className={styles.sitAndGoLogo} />;

    case StepKeyName.step2Scheduled:
      return <div className={styles.label}>{tournament}</div>;

    case StepKeyName.step3:
      return <div className={styles.label}>{tournament}</div>;

    case StepKeyName.step4:
      return (
        <div className={classNames(styles.label, styles.finalStep)}>
          <span>{final}</span>
          <span>{tournament}</span>
        </div>
      );
  }

  return null;
};

export default BannerName;
